import { HERO_IMAGES, LOGO_DARK } from "@/lib/constants";
import { useI18n } from "@/lib/i18n";

export default function Hero() {
  const { t } = useI18n();

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative w-full min-h-[100svh] overflow-hidden bg-[#1A1713]"
    >
      {/* Background photography — Ken-Burns slow zoom */}
      <div
        className="absolute inset-0 bg-cover bg-center kenburns"
        style={{ backgroundImage: `url(${HERO_IMAGES.brasserie})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#1A1713]/40 via-[#1A1713]/30 to-[#1A1713]/80" />

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 h-[100svh] flex flex-col justify-between pt-32 pb-14">
        {/* Top kicker — 37% larger per spec */}
        <div className="flex items-center justify-between text-[#FDFBF7]/85">
          <span
            data-testid="hero-location"
            className="font-mono-accent text-[14px] md:text-[15px]"
          >
            {t("hero.location")}
          </span>
          <span className="hidden md:block font-mono-accent text-[14px] md:text-[15px]">
            29° 44′ N / 95° 22′ W
          </span>
        </div>

        {/* Centerpiece — logo replaces wordmark, kicker 37% larger */}
        <div className="max-w-5xl">
          <p
            data-testid="hero-kicker"
            className="font-mono-accent text-[14px] md:text-[15px] text-[#C98A4B] mb-7 fade-up"
          >
            {t("hero.kicker")}
          </p>
          <img
            src={LOGO_DARK}
            alt="Ladiosa's"
            data-testid="hero-heading"
            className="logo-in w-full max-w-[640px] md:max-w-[820px] lg:max-w-[920px] h-auto object-contain -ml-4 md:-ml-6"
          />
          <p
            className="mt-4 text-[#FDFBF7]/85 text-base md:text-lg max-w-xl font-light leading-relaxed fade-up"
            style={{ animationDelay: "0.25s" }}
          >
            {t("hero.tagline")}
          </p>
          <div
            className="mt-10 flex flex-wrap items-center gap-4 fade-up"
            style={{ animationDelay: "0.4s" }}
          >
            <a
              href="#reserve"
              data-testid="hero-reserve-btn"
              className="font-mono-accent text-[13px] bg-[#FDFBF7] text-[#1A1713] px-7 py-4 hover:bg-[#C98A4B] hover:text-[#FDFBF7] transition-all duration-500"
            >
              {t("hero.cta_reserve")}
            </a>
            <a
              href="#menu"
              data-testid="hero-menu-btn"
              className="font-mono-accent text-[13px] text-[#FDFBF7] border border-[#FDFBF7]/40 px-7 py-4 hover:border-[#FDFBF7] transition-all duration-500"
            >
              {t("hero.cta_menu")}
            </a>
          </div>
        </div>

        {/* Bottom rail */}
        <div className="flex items-end justify-between text-[#FDFBF7]/70">
          <div className="hidden md:block max-w-xs">
            <p className="font-mono-accent text-[12px] mb-3">{t("hero.now_serving")}</p>
            <p className="font-serif-display text-2xl text-[#FDFBF7] italic leading-snug">
              {t("hero.quote")}
            </p>
          </div>
          <div className="text-right">
            <p className="font-mono-accent text-[12px] mb-1">{t("hero.scroll")}</p>
            <div className="w-px h-12 bg-[#FDFBF7]/40 ml-auto" />
          </div>
        </div>
      </div>
    </section>
  );
}
